import React, { useState, useEffect } from 'react'
import './style.scss'
import { Routes, Route, useNavigate } from 'react-router-dom'

import Layout from '../../../components/layout/Index'
import Layout2 from '../../../components/layout/Index2'

import DashboardIndex from '../dashboard/Index'
import EmailIndext from '../email/Index'

// Website
import BannerIndex from '../website/banner/Index'
import BannerCreate from '../website/banner/Create'
import StoryIndex from '../website/story/Index'
import StoryStore from '../website/story/Create'
import StoryShow from '../website/story/Show'
import StoryEdit from '../website/story/Edit'

import ProfilesByProfessionIndex from '../website/profilesByProfession/Index'
import ProfilesByProfessionStore from '../website/profilesByProfession/Create'
import ProfilesByProfessionShow from '../website/profilesByProfession/Show'
import ProfilesByProfessionEdit from '../website/profilesByProfession/Edit'

import AboutUsIndex from '../website/AboutUS/Index'
// import AboutUsStore from '../website/AboutUS/Create'
import AboutUsShow from '../website/AboutUS/Show'
import AboutUsEdit from '../website/AboutUS/Edit'
import ContactUsIndex from '../website/ContactUs/Index'
// import ContactUsStore from '../website/ContactUs/Create'
import ContactUsShow from '../website/ContactUs/Show'
import ContactUsEdit from '../website/ContactUs/Edit'
import TermsIndex from '../website/TermsAndConditions/Index'
// import TermsStore from '../website/TermsAndConditions/Create'
import TermsShow from '../website/TermsAndConditions/Show'
import TermsEdit from '../website/TermsAndConditions/Edit'
import MarriageCounsellingIndex from '../website/MarriageCounseling/Index'
// import MarriageCounsellingStore from '../website/MarriageCounseling/Create'
import MarriageCounsellingShow from '../website/MarriageCounseling/Show'
import MarriageCounsellingEdit from '../website/MarriageCounseling/Edit'
import PremiumIndex from '../website/Premium/Index'
// import PremiumStore from '../website/Premium/Create'
import PremiumShow from '../website/Premium/Show'
import PremiumEdit from '../website/Premium/Edit'
import BlogIndex from '../website/blog/Index'
import BlogStore from '../website/blog/Create'
import BlogShow from '../website/blog/Show'
import BlogEdit from '../website/blog/Edit'
import SettingFieldIndex from '../website/settingFields/Index'
import SettingFieldCreate from '../website/settingFields/Create'
import SettingFieldValueIndex from '../website/settingFieldValue/Index'
import SettingFieldValueEdit from '../website/settingFieldValue/Edit'


// Area Profile
import AreaProfileIndex from '../website/AreaProfile/Index'
import AreaProfileStore from '../website/AreaProfile/Create'
// import AreaProfileShow from '../website/AreaProfile/Show'
// import AreaProfileEdit from '../website/AreaProfile/Edit'

// Expert Counselors Profile
import ExpertCounselorsProfileIndex from '../website/ExpertCounselorsProfile/Index'
import ExpertCounselorsProfileStore from '../website/ExpertCounselorsProfile/Create'
import ExpertCounselorsProfileShow from '../website/ExpertCounselorsProfile/Show'
import ExpertCounselorsProfileEdit from '../website/ExpertCounselorsProfile/Edit'

// Appointment Booking
import AppointmentBookingIndex from '../website/AppointmentBooking/Index'
import AppointmentBookingStore from '../website/AppointmentBooking/Create'
import AppointmentBookingShow from '../website/AppointmentBooking/Show'
import AppointmentBookingEdit from '../website/AppointmentBooking/Edit'

// Verification Service
import VerificationServiceIndex from '../website/VerificationService/Index'
import VerificationServiceStore from '../website/VerificationService/Create'
import VerificationServiceShow from '../website/VerificationService/Show'
import VerificationServiceEdit from '../website/VerificationService/Edit'

// Feature Profile
import FeatureProfileIndex from '../website/FeatureProfile/Index'
import FeatureProfileStore from '../website/FeatureProfile/Create'
// import AreaProfileShow from '../website/AreaProfile/Show'
// import AreaProfileEdit from '../website/AreaProfile/Edit'

// Accounts
import PackageSaleIndex from '../accounts/packageSales/Index'
import PackageSaleStore from '../accounts/packageSales/Create'
import PackageSaleEdit from '../accounts/packageSales/Edit'
import PackageSaleShow from '../accounts/packageSales/Show'
import AccountIndex from '../accounts/account/Index'
import Expense from '../accounts/Expense/Expense'
import ExpenseCreate from '../accounts/Expense/Create'
import ExpenseShow from '../accounts/Expense/Show'
import ExpenseUpdate from '../accounts/Expense/Update'

// User Pages
import UsersIndex from '../users/Index'
import UsersIndex2 from '../users/Index2'

import UserShow from '../users/Show'
import UserLogs from '../users/Logs'
import UserEdit from "../users/Edit"
import PaymentHistory from '../users/Payment'
// Membership Package Pages
import PackageIndex from '../membership-packages/Index'
import PackageCreate from '../membership-packages/Create'
import PackageEdit from '../membership-packages/Edit'

// Marketing
//// E-mail
import MarketingEmailIndex from '../marketing/email/Create'
import MarketingEmailHistory from '../marketing/email/History'
// sms
import MarketingSMSCreate from '../marketing/sms/Create'
import MarketingSMSHistory from '../marketing/sms/History'
// Addsesnse
import AddsenseIndex from '../marketing/addsense/Index'
// import AddsenseCreate from '../marketing/addsense/Create'
import AddsenseUpdate from '../marketing/addsense/Update'

//HRM
import HRMDashboard from '../hrm/Dashboard'
import HRMEmployees from '../hrm/Employees'
import HRMUsers from '../hrm/Users'
import HRMUsersEdit from '../hrm/EditHrm'

//Ghotok 
import PendingGhotoks from '../ghotok/PendingGhotok'
import RejectGhotoks from '../ghotok/RejectGhotok'
import SellsPackageGhotok from "../ghotok/PackageSells"
import ComissionsGhotok from "../ghotok/comission/Comission"
import WithdrawGhotok from "../ghotok/WithdrowRequests"
import GhotokAccount from "../ghotok/GhotokAccount"
import GhotokProfile from "../ghotok/ghotok_profile/Index"
import GhotokProfileEdit from "../ghotok/ghotok_profile/ghotok_profile_edit"
import AddComission from "../ghotok/comission/CreateComission"
import ComissionEdit from "../ghotok/comission/Edit"
import WithdrawTransection from "../ghotok/Transection"
// import phoneVerified from "../ghotok/Otp"
import ApprovedGhotoks from "../ghotok/approvedGhotok/Index"
//Premium
import Premium from "../premium/index"

// Notice board
import NoticeBoardIndex from '../notice-board/Index'
import ManagerNoticeBoardIndex from '../notice-board/IndexManager'

// Four O Four Page
import FourOFour from '../fourOfour/Index'

import { checkUserRole } from '../../../utils/Authenticate'
import AgentsUser from "../ghotok/AgentsUserList"


const Index = () => {
    const [userRole, setUserRole] = useState(null)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setUserRole(checkUserRole())
        setLoading(true)
    }, [])

    if (!userRole && loading){
        localStorage.clear()
        navigate('/')
    }
    
    return (
        <div className="master">
            {
                (userRole !== 'admin' && userRole !== 'super_admin')
                    ? <Layout2 />
                    : <Layout />
            }

            <div className="main">
                <Routes>
                    <Route path="/" element={<DashboardIndex />} />
                    <Route path="users"
                        element={(userRole !== 'admin' && userRole !== 'super_admin')
                            ? <UsersIndex2 /> : <UsersIndex />} />
                    <Route path="user/:id/show/*" element={<UserShow />} />
                    <Route path="user/:id/edit" element={<UserEdit />} />
                    <Route path="user/:email/logs" element={<UserLogs />} />
                    <Route path="user/:id/payment" element={<PaymentHistory />} />
                    <Route path="users/emailusers/:email/:gender" element={<EmailIndext />} />
                    {/* Website */}
                    <Route path="website/banner" element={<BannerIndex />} />
                    <Route path="website/banner/store" element={<BannerCreate />} />
                    
                    {/* ProfilesByProfession */}
                    <Route path="website/profiles-by-profession" element={<ProfilesByProfessionIndex />} />
                    <Route path="website/profiles-by-profession/store" element={<ProfilesByProfessionStore />} />
                    <Route path="website/profiles-by-profession/:id/edit" element={<ProfilesByProfessionEdit />} />
                    <Route path="website/profiles-by-profession/:id/show" element={<ProfilesByProfessionShow />} />

                    <Route path="website/story" element={<StoryIndex />} />
                    <Route path="website/story/store" element={<StoryStore />} />
                    <Route path="website/story/:id/edit" element={<StoryEdit />} />
                    <Route path="website/story/:id/show" element={<StoryShow />} />

                    <Route path="website/about-us" element={<AboutUsIndex />} />
                    {/* <Route path="website/about-us/store" element={<AboutUsStore />} /> */}
                    <Route path="website/about-us/:id/edit" element={<AboutUsEdit />} />
                    <Route path="website/about-us/:id/show" element={<AboutUsShow />} />
                    
                    <Route path="website/contact-us" element={<ContactUsIndex />} />
                    {/* <Route path="website/contact-us/store" element={<ContactUsStore />} /> */}
                    <Route path="website/contact-us/:id/edit" element={<ContactUsEdit />} />
                    <Route path="website/contact-us/:id/show" element={<ContactUsShow />} />

                    <Route path="website/terms-and-conditions" element={<TermsIndex />} />
                    {/* <Route path="website/terms-and-conditions/store" element={<TermsStore />} /> */}
                    <Route path="website/terms-and-conditions/:id/edit" element={<TermsEdit />} />
                    <Route path="website/terms-and-conditions/:id/show" element={<TermsShow />} />

                    <Route path="website/premium" element={<PremiumIndex />} />
                    {/* <Route path="website/premium/store" element={<PremiumStore />} /> */}
                    <Route path="website/premium/:id/edit" element={<PremiumEdit />} />
                    <Route path="website/premium/:id/show" element={<PremiumShow />} />

                    <Route path="website/marriage-counselling" element={<MarriageCounsellingIndex />} />
                    {/* <Route path="website/marriage-counselling/store" element={<MarriageCounsellingStore />} /> */}
                    <Route path="website/marriage-counselling/:id/edit" element={<MarriageCounsellingEdit />} />
                    <Route path="website/marriage-counselling/:id/show" element={<MarriageCounsellingShow />} />

                    <Route path="website/area-profile" element={<AreaProfileIndex />} />
                    <Route path="website/area-profile/store" element={<AreaProfileStore />} />

                    {/* Expert Counselors Profile */}
                    <Route path="website/expert-counselors-profile" element={<ExpertCounselorsProfileIndex />} />
                    <Route path="website/expert-counselors-profile/store" element={<ExpertCounselorsProfileStore />} />
                     <Route path="website/expert-counselors-profile/:id/edit" element={<ExpertCounselorsProfileEdit />} />
                    <Route path="website/expert-counselors-profile/:id/show" element={<ExpertCounselorsProfileShow />} /> 

                    {/* Appointment Booking */}
                    <Route path="website/appointment-booking" element={<AppointmentBookingIndex />} />
                    <Route path="website/appointment-booking/store" element={<AppointmentBookingStore />} />
                     <Route path="website/appointment-booking/:id/edit" element={<AppointmentBookingEdit />} />
                    <Route path="website/appointment-booking/:id/show" element={<AppointmentBookingShow />} /> 

                    {/* Verification Service */}
                    <Route path="website/verification-service" element={<VerificationServiceIndex />} />
                    <Route path="website/verification-service/store" element={<VerificationServiceStore />} />
                     <Route path="website/verification-service/:id/edit" element={<VerificationServiceEdit />} />
                    <Route path="website/verification-service/:id/show" element={<VerificationServiceShow />} /> 

                    <Route path="website/feature-profile" element={<FeatureProfileIndex />} />
                    <Route path="website/feature-profile/store" element={<FeatureProfileStore />} />
                     {/*<Route path="website/blog/:id/edit" element={<BlogEdit />} />
                    <Route path="website/blog/:id/show" element={<BlogShow />} /> */}

                    <Route path="website/blog" element={<BlogIndex />} />
                    <Route path="website/blog/store" element={<BlogStore />} />
                    <Route path="website/blog/:id/edit" element={<BlogEdit />} />
                    <Route path="website/blog/:id/show" element={<BlogShow />} />
                    <Route path="website/settings-field" element={<SettingFieldIndex />} />
                    <Route path="website/settings-field/store" element={<SettingFieldCreate />} />
                    <Route path="website/settings-field/value" element={<SettingFieldValueIndex />} />
                    <Route path="website/settings-field/value/:id/edit" element={<SettingFieldValueEdit />} />

                    {/* Accounts */}
                    <Route path="accounts/account" element={<AccountIndex />} />
                    <Route path="accounts/sales" element={<PackageSaleIndex />} />
                    <Route path="accounts/sales/store" element={<PackageSaleStore />} />
                    <Route path="accounts/sales/:id/edit" element={<PackageSaleEdit />} />
                    <Route path="accounts/sales/:id/show" element={<PackageSaleShow />} />
                    <Route path="accounts/expense" element={<Expense />} />
                    <Route path="accounts/expense/create" element={<ExpenseCreate />} />
                    <Route path="accounts/expense/:id/show" element={<ExpenseShow />} />
                    <Route path="accounts/expense/:id/update" element={<ExpenseUpdate />} />

                    {/* Membership package */}
                    <Route path="membership-packages" element={<PackageIndex />} />
                    <Route path="membership-packages/create" element={<PackageCreate />} />
                    <Route path="membership-packages/:id/edit" element={<PackageEdit />} />


                    {/* {HRM} */}
                    <Route path="hrm/dashboard" element={<HRMDashboard />} />
                    <Route path="hrm/user" element={<HRMUsers />} />
                    <Route path="hrm/user/:email/update" element={<HRMUsersEdit />} />
                    <Route path="hrm/employee" element={<HRMEmployees />} />

                    {/* Premium */}
                    <Route path="premium" element={<Premium />} />


                    {/* Ghotok */}
                    <Route path="agents/approved" element={<ApprovedGhotoks />} />
                    <Route path="agents/pending" element={<PendingGhotoks />} />
                    <Route path="agents/reject" element={<RejectGhotoks />} />
                    <Route path="agents/sells" element={<SellsPackageGhotok />} />
                    <Route path="agents/withdraw" element={<WithdrawGhotok />} />
                    <Route path="agents/transection" element={<WithdrawTransection />} />
                    <Route path="agents/create" element={<GhotokAccount />} />
                    <Route path="agents/:id/phone-verified" element={<phoneVerified />} />
                    <Route path="agents/:id/show" element={<GhotokProfile />} />
                    <Route path="agents/:id/update" element={<GhotokProfileEdit />} />
                    <Route path="agents/comission" element={<ComissionsGhotok />} />
                    <Route path="create/comission" element={<AddComission />} />
                    <Route path="comission/:id/edit" element={<ComissionEdit />} />
                    <Route path="agents/:id/users" element={<AgentsUser />} />

                    {/* ///// E-mail ///// */}
                    {/* Marketing */}
                    <Route path="marketing/email" element={<MarketingEmailIndex />} />
                    <Route path="marketing/email/history" element={<MarketingEmailHistory />} />
                    <Route path="marketing/sms" element={<MarketingSMSCreate />} />
                    <Route path="marketing/sms/history" element={<MarketingSMSHistory />} />
                    <Route path="marketing/web-ad" element={<AddsenseIndex />} />
                    {/* <Route path="marketing/web-ad/create" element={<AddsenseCreate />} /> // need comment */}
                    <Route path="marketing/web-ad/update/:id" element={<AddsenseUpdate />} />


                    <Route path="notice-board" element={<NoticeBoardIndex />} />
                    <Route path="manager-notice-board" element={<ManagerNoticeBoardIndex />} />

                    <Route path="*" element={<FourOFour />} />
                </Routes>
            </div>
        </div>
    );
}

export default Index;